import { gql, useMutation } from '@apollo/client';

const UPDATE_AUDIT_POLICY_SNIPPET = gql`
  mutation UpdateAuditPolicySnippet($id: String, $serviceName: String!, $categoryKey: String!, $snippet: String!) {
    updateAuditPolicySnippet(id: $id, serviceName: $serviceName, categoryKey: $categoryKey, snippet: $snippet) {
      id
      description
      snippet
      createdAt
      updatedAt
    }
  }
`;

export interface UpdateAuditPolicySnippetVariables {
  id?: string;
  serviceName: string;
  categoryKey: string;
  snippet: string;
}

export interface UpdateAuditPolicySnippetResult {
  id: string;
  description: string;
  snippet: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateAuditPolicySnippetData {
  updateAuditPolicySnippet: UpdateAuditPolicySnippetResult;
}

export function useUpdateAuditPolicySnippetMutation() {
  return useMutation<UpdateAuditPolicySnippetData, UpdateAuditPolicySnippetVariables>(UPDATE_AUDIT_POLICY_SNIPPET);
}
